import axios from "axios";
import { toast } from "react-toastify";

export const FETCH_SETTLEMENTS_REQUEST = "FETCH_SETTLEMENTS_REQUEST";
export const FETCH_SETTLEMENTS_SUCCESS = "FETCH_SETTLEMENTS_SUCCESS";
export const FETCH_SETTLEMENTS_FAILURE = "FETCH_SETTLEMENTS_FAILURE";
export const PROCESS_PAYOUT_SUCCESS = "PROCESS_PAYOUT_SUCCESS";

export const fetchSettlements = (params) => async (dispatch, getState) => {
  dispatch({ type: FETCH_SETTLEMENTS_REQUEST });
  
  try {
    const { AuthReducer: { auth } } = getState();
    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined && value !== null && value !== '')
    );
    
    const response = await axios.get("/api/admin/v1/settlements", {
      headers: { Authorization: `Bearer ${auth?.token}` },
      params: cleanParams,
    });

    dispatch({
      type: FETCH_SETTLEMENTS_SUCCESS,
      payload: {
        settlements: response.data.settlements || [],
        count: response.data.totalCount || 0
      }
    });
  } catch (error) {
    dispatch({
      type: FETCH_SETTLEMENTS_FAILURE,
      payload: error.response?.data?.message || "Failed to fetch settlements"
    });
    toast.error("Failed to fetch settlements");
  }
};

export const processPayout = (settlementId) => async (dispatch, getState) => {
  try {
    const { AuthReducer: { auth } } = getState();
    await axios.put(`/api/admin/v1/settlement-payout/${settlementId}`, {}, {
      headers: { Authorization: `Bearer ${auth?.token}` },
    });
    
    dispatch({
      type: PROCESS_PAYOUT_SUCCESS,
      payload: settlementId
    });
    
    toast.success("Payout processed successfully");
  } catch (error) {
    toast.error("Failed to process payout");
  }
};